import React from 'react';
import logo from './logo.svg';
import './App.css';
import Routes from "./config/Routes";
import {Helmet} from "react-helmet/es/Helmet";
import Navbar from "./containers/pages/shared/Navbar";
import 'jquery/dist/jquery.min'
import Footer from "./containers/pages/shared/Footer";
// import  './js/jquery.dropotron.min'
// import  './js/jquery.scrollex.min'
// import './js/browser.min'
// import './js/util'
// import './js/main'


function App() {
  return (
    <div id={"page-wrapper"}>
        <Routes/>
        <Helmet titleTemplate='%s | Portfolio' defaultTitle={"Portfolio"}/>
        <meta name={"description"} content={'Isaac Browne portfolio'}/>

        {/*<Navbar/>*/}
      <Footer/>
    </div>

  );
}

export default App;
